/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

 Shopify.Products = (function() {
   var $ = jQuery;

   var config = {
     howManyToShow: 6,
     howManyToStoreInMemory: 10,
     wrapperId: 'recently-viewed-products',
     templateId: 'recently-viewed-product-template',
     onComplete: null,
     showVendor: false,
     buttonText: "Quick shop",
     moneyFormat: $(document.documentElement).data("moneyformat")
   };

   var productHandleQueue = [];
   var wrapper = null;
   var template = null;
   var shown = 0;

   var cookie = {
     configuration: {
       expires: 90,
       path: '/',
       domain: window.location.hostname
     },
     name: 'shopify_recently_viewed',
     write: function(recentlyViewed) {
       jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
     },
     read: function() {
       var recentlyViewed = [];
       var cookieValue = jQuery.cookie(this.name);
       if (cookieValue !== null) {
         recentlyViewed = cookieValue.split(' ');
       }
       return recentlyViewed;
     },
     destroy: function() {
       jQuery.cookie(this.name, null, this.configuration);
     },
     remove: function(productHandle) {
       var recentlyViewed = this.read();
       var position = jQuery.inArray(productHandle, recentlyViewed);
       if (position !== -1) {
         recentlyViewed.splice(position, 1);
         this.write(recentlyViewed);
       }
     }
   };

   var finalize = function() {
     $('body').trigger('lazyload-again', [wrapper]);
     wrapper.show();
     $(window).resize();
     // If we have a callback.
     if (config.onComplete) {
       try { config.onComplete() } catch (error) { }
     }
     // _swat.initializeActionButtons('.template-product');

     $('#recently-viewed-products').children('li').addClass('cont');
     $('#recently-viewed-products').filter('.slider').each(function() {
       // if ($(this).children().length > 3) {
         $(this).owlLayout().children('.inner').owlCarousel({
           loop: false,
           nav: true,
           dots: false,
           autoHeight: true,
           lazyLoad: true,
           margin: ($(this).is('.box') ? 18 : 22),
           items: 4,
           onInitialized: function() {
             $(this.$element).owlSemantic();
           },
           onTranslated: function() {
             $(this.$element).owlSemantic();
           },
           responsive: {
             0: {
               items: 1,
               margin: 0
             },
             760: {
               items: 3,
               margin: 0
             },
             1000: {
               items: 4,
               margin: 0
             },
             1400: {
               items: 4,
               margin: ($(this).is('.box') ? 18 : 22)
             }
           }
         });
       // }
     });

   };

   var moveAlong = function() {
     if (productHandleQueue.length && shown < config.howManyToShow) {
       jQuery.ajax({
         url: '/products/' + productHandleQueue[0] + '?view=quickshop',
         cache: false,
         success: function(data) {
           var data = JSON.parse(data);
           var product = data.product;
           if (product.type != 'Accessoires') {
             
               var product_price = Shopify.formatMoney(product.price, config.moneyFormat).replace( /(\,\d+)$/, '<sup>$1</sup>');
             
           } else {
           	var product_price = Shopify.formatMoney(product.price, config.moneyFormat).replace( /(\,\d+)$/, '<sup>$1</sup>');
           }

             customer_type = $(document.getElementsByClassName('customer-type'))[0].innerText;
             customer_tag = $(document.getElementsByClassName('customer-tag'));
             product_vendor = product.vendor.toLowerCase()

             var isKorting = false;
             var isInkoop = false;
             var isPromo = false;
             var discount = 1;
             var retaildiscount = 1;
             var promodiscount = 1;
             var percentage;
             let tags = new Array(1);

             for (let i = 0; i < customer_tag.length; i++) {
                 if (customer_tag[i] !== undefined) {
                     tags.push(customer_tag[i].innerText)
                 }
             }

             for (let tag in tags) {
                 if (tags[tag].includes('korting|' + product_vendor)) {
                     let temp_tag = tags[tag].split('|')
                     percentage = temp_tag[2]
                     retaildiscount = 1 - (percentage/100)
                     isKorting = true;
                 }
             }

             for (let tag in tags) {
                 if (tags[tag].includes('inkoop|' + product_vendor)) {
                     let temp_tag = tags[tag].split('|')
                     percentage = temp_tag[2]
                     discount = 1 - (percentage/100)
                     isInkoop = true;
                 }
             }

             for (let tag in tags) {
                 if (tags[tag].includes('promotie|' + product_vendor)) {
                     let temp_tag = tags[tag].split('|')
                     percentage = temp_tag[2]
                     promodiscount = 1 - (percentage/100)
                     isPromo = true;
                 }
             }

           var price = Shopify.formatMoney((product.price / 121 * 100 * discount), config.moneyFormat).replace( /(\,\d+)$/, '<sup>$1</sup>');
           var promowoonprof = Shopify.formatMoney((product.price / 121 * 100 * discount * promodiscount), config.moneyFormat).replace( /(\,\d+)$/, '<sup>$1</sup>');
           var retailprijs = Shopify.formatMoney((product.price / 121 * 100 * discount * retaildiscount * promodiscount), config.moneyFormat).replace( /(\,\d+)$/, '<sup>$1</sup>');

             var stock = '';
           var showPlaceholder = false;
           if (product.featured_image == null) {
             showPlaceholder = true;
           }
           var number = Math.floor(Math.random() * (6 - 1 + 1)) + 1;
           var number1 = false;
           var number2 = false;
           var number3 = false;
           var number4 = false;
           var number5 = false;
           var number6 = false;
           switch(number) {
            case 1:
              number1 = true;
              break;
            case 2:
              number2 = true;
              break;
            case 3:
              number3 = true;
              break;
            case 4:
              number4 = true;
              break;
            case 5:
              number5 = true;
              break;
            case 6:
              number6 = true;
              break;
          }
           if (product.images.length > 1 ) {
             var showSecond = true;
             var secondImage = Shopify.Products.resizeImage(product.images[1]);
           } else {
             var showSecond = false;
           }
            var dataTitle = product.title;
           var shortTitle = '';
           var showShortTitle = false;
            var split = dataTitle.split("rkleed");
            if (split.length > 1 && split[split.length-1] != '' ) {
              showShortTitle = true;
              shortTitle = split[split.length-1].replace(product.vendor, '').replace('Louis De Poortere', '');
            } 
           item = {
               number1: number1,
               number2: number2,
               number3: number3,
               number4: number4,
               number5: number5,
               number6: number6,
               url: data.product_url,
               product_id: data.product.id,
               handle: product.handle,
             	vendor: product.vendor,
               featured_image: Shopify.Products.resizeImage(product.featured_image),
               show_placeholder: showPlaceholder,
               show_second: showSecond,
               second_image: secondImage,
             	show_short_title: showShortTitle,
               title: product.title,
               short_title: shortTitle,
               adviesprijs: product_price,
               stock: stock,
               button_text: config.buttonText,
               price: price,
               promowoonprof: promowoonprof,
               retailprijs: retailprijs,
               customertype: customer_type,
               isKorting: isKorting,
               isInkoop: isInkoop,
               isPromo: isPromo
           };

           wrapper.append(templateHandlebar(item));
           productHandleQueue.shift();
           shown++;
           moveAlong();
         },
         error: function() {
           cookie.remove(productHandleQueue[0]);
           productHandleQueue.shift();
           moveAlong();
         }
       });
     }
     else {
       finalize();
     }

   };

   return {

     resizeImage: function(src, size) {
       if (size == null) {
         return src;
       }

       if (size == 'master') {
         return src.replace(/http(s)?:/, "");
       }

       var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

       if (match != null) {
         var prefix = src.split(match[0]);
         var suffix = match[0];

         return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
       } else {
         return null;
       }
     },

     showRecentlyViewed: function(params) {
       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read();

       // Template and element where to insert.
       template = jQuery('#' + config.templateId);
       templateHTML = template.html();
       wrapper = jQuery('#' + config.wrapperId);
       templateHandlebar = Handlebars.compile(templateHTML);

       // How many products to show.
       config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

       // If we have any to show.
       if (config.howManyToShow && template.length && wrapper.length) {
         // Getting each product with an Ajax call and rendering it on the page.
         moveAlong();
       }

     },

     getConfig: function() {
       return config;
     },

     clearList: function() {
       cookie.destroy();
     },

     recordRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var recentlyViewed = cookie.read();

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1) {

         // What is the product handle on this page.
         var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, recentlyViewed);
         // If not in memory.
         if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);
         }

         // Update cookie.
         cookie.write(recentlyViewed);

       }

     }

   };

 })();


Shopify.Products.recordRecentlyViewed();
Shopify.Products.showRecentlyViewed();
